import store from '../state/store';
import { selectUniqueId } from '../state/singleInstance/singleInstanceSlice';

const sendBroadcast = () => new Promise((resolve, reject) => {
  if (typeof BroadcastChannel === 'undefined') {
    reject(new Error('BroadcastChannel unavailable'));
    return;
  }

  const uniqueId = selectUniqueId(store.getState());
  const channel = new BroadcastChannel('refresh');

  const timeout = setTimeout(() => {
    channel.close();
    reject(new Error('No response from another instance.'));
  }, 1000);

  channel.onmessage = (event) => {
    const msg = event.data;
    if (msg?.msg === 'quiet, they are listening') {
      clearTimeout(timeout);
      channel.close();
      resolve();
    }
  };

  channel.postMessage({ msg: 'reload check', uniqueId });
});

export default sendBroadcast;
